// extracted by mini-css-extract-plugin
module.exports = {"StatusWrapper":"Status_StatusWrapper__3VWVD","Status":"Status_Status__1G8jl","Up":"Status_Up__2B3jk"};